import {ADD_IMAGE, 
        DELETE_IMAGE, 
        REMOVE_IMAGE, 
        MODIFY_IMAGE_SOURCE, 
        MODIFY_IMAGE_DESC,
        CARREGAR_IMAGES_SERVER,
        CARREGAR_IMAGES_STORE,
        ADD_IMAGE_STORE,
        DELETE_IMAGE_STORE}       
        from '../constants/constants'

export const adicionarImagem = (img, desc = '') => ({
    type : ADD_IMAGE, img, desc, id : Date.now()
})

export const adicionarImagemStore = (img, desc, id) =>({
    type : ADD_IMAGE_STORE, img, desc, id
})

export const removerImagem = (id) => ({
    type : REMOVE_IMAGE, id
})

export const deletarImagem = (id) => ({
    type : DELETE_IMAGE, id
})

export const deletarImagemStore = (id) => ({
    type : DELETE_IMAGE_STORE, id
})

export const modificarFonteImagem = (id, img) => ({
    type : MODIFY_IMAGE_SOURCE, img, id
})

export const modificarDescImagem = (id, desc) => ({
    type : MODIFY_IMAGE_DESC, desc, id
})

export const carregarImagensDoServer = () => ({
    type : CARREGAR_IMAGES_SERVER
})

export const carregarImagensNaStore = (imagens) => ({
    type : CARREGAR_IMAGES_STORE,
    imagens
})

export default {adicionarImagem, removerImagem, deletarImagem, modificarDescImagem, modificarFonteImagem}

window.adicionarImagem = adicionarImagem;
window.removerImagem = removerImagem;
window.deletarImagem = deletarImagem;
window.modificarDescImagem = modificarDescImagem;
window.modificarFonteImagem = modificarFonteImagem;
window.carregarImagensNaStore = carregarImagensNaStore;
window.carregarImagensDoServer = carregarImagensDoServer;


// WEBPACK FOOTER //
// ./src/actions/imagem.js